import { AppProvider } from "./appContext";
import { PlayerProvider } from "./playerContext";

const Providers = (props: any) => {
  return (
    <PlayerProvider>
      <AppProvider {...props} />
    </PlayerProvider>
  );
};

export default Providers;
